import { render } from "./BiggestDiscountsVouchersPage.vue?vue&type=template&id=37393dec&scoped=true"
import script from "./BiggestDiscountsVouchersPage.vue?vue&type=script&lang=js"
export * from "./BiggestDiscountsVouchersPage.vue?vue&type=script&lang=js"

import "./BiggestDiscountsVouchersPage.vue?vue&type=style&index=0&id=37393dec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37393dec"]])

export default __exports__